export default __webpack_public_path__ + "static/equitrip-f236a87c061f32b437f3b883c00b4998.webp";